import { FC, CSSProperties } from 'react';
import { YodaColors } from '../../yoda-ui/yodaTheme';

type ArrowDownIconProps = {
  style?: CSSProperties;
  className?: string;
};

const ArrowRightIcon: FC<ArrowDownIconProps> = ({ style, className }) => {
  const defaultColorStyle = style?.color === undefined ? { color: YodaColors.textPrimary } : {};

  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={
        {
          ...defaultColorStyle,
          ...style,
        }
      }
      className={ className }
    >
      <path
        transform="rotate(-90 8 8)"
        // eslint-disable-next-line max-len
        d="M14 5.3335L8.28267 10.5597C8.24557 10.5937 8.2015 10.6206 8.153 10.639C8.1045 10.6574 8.05251 10.6668 8 10.6668C7.94749 10.6668 7.8955 10.6574 7.847 10.639C7.7985 10.6206 7.75444 10.5937 7.71733 10.5597L2 5.3335"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default ArrowRightIcon;
